import {ZytdItemDetail} from './zytd-item-detail';

export const zytdDetailEntities: ZytdItemDetail [] = [
  /*  {   id: 1,
        route: '',
        itemName: '李丽',
        contents: [{
            id: 1, contentTitle: '专业任职', values: [
                {id: 1, value: '国家标准《知识产权评议标准》标准专家'},
                {id: 2, value: '国家知识产权百千万人才工程百名高层次人才'},
                {id: 3, value: '知锦、集慧智佳知识产权咨询、集佳上海分所团队创始人'},
                {id: 4, value: '企业知识产权管理者'},
                {id: 5, value: '产品总监'},
            ],},{
            id: 2, contentTitle: '工作经历', values:[
                {id: 1, value: '2017年-至今，创办上海知锦知识产权代理事务所及其北京办公室'},
                {id: 2, value: '2015年-2017年，清华外聘讲师，参加RTTP国际技术转移经理人培训，对接项目投融资、技术转移及知识产权相关事宜'},
                {id: 3, value: '2010年-2015年，跨国并购尽调项目经理及联合主导车联网企业近300件专利布局，创建知识产权咨询团队（2011年独立，现为北京集慧智佳知识产权管理咨询有限公司）'},
                {id: 4, value: '2005年-2009年，创办集佳上海分所并成为合伙人，主管专利业务，创建专注于半导体领域专利服务体系，并纵深该领域，致力于高质量案件处理'},
                {id: 5, value: '2003年，北京集佳知识产权代理有限公司，软件与通信领域专利撰写方法研究及实践'},
                {id: 6, value: '2000年，跨国企业集团知识产权室，负责通信团队，专利部署、管理、挖掘及申请等事务；针对公司研发或投资活动，带领团队完成多项具有参考价值及创新性的专利战略等报告'}
            ],},{
            id: 3, contentTitle: '特色成果', values:[
                {id: 1, value: '清华大学授课：《专利信息利用》'},
                {id: 2, value: '撰写《专利信息利用——以需求为中心的方法、实务与案例》'},
                {id: 3, value: '国家标准《知识产权评议标准》标准专家'}
            ],}
        ],
    },

    {   id: 2,
        route: '',
        itemName: '高静',
        contents: [{
            id: 1, contentTitle: '专业任职', values:  [
                {id: 1, value: '深耕集成电路知识产权领域'},
                {id: 2, value: 'LCD产品工程师'},
                {id: 3, value: '专利代理人、团队负责人、合伙人'}
        ],},{
            id: 2, contentTitle: '工作经历', values: [
        ],},{
            id: 3, contentTitle: '教育经历', values:[
                {id: 1, value: '复旦大学，光学硕士'}
        ],},{
            id: 4, contentTitle: '特色成果', values: [
                {id: 1, value: '撰写300件以上，核稿800件以上，审查意见答复400次以上'},
                {id: 2, value: '无效以及复审10件以上，专利检索以及侵权分析5件以上'},
                {id: 3, value: '专利挖掘和专利知识培训'},
                {id: 4, value: '发表文章：《专利创造性评价中的事实认定——以审查意见答复为例》，《知识产权战略与实务》第8辑；《专利创造性评价中的“近位原则》，《知识产权战略与实务》第10辑'},
            ],},{
                id: 5, contentTitle: '服务领域', values: [
                    {id: 1, value: '半导体、显示设备、触控检测、指纹识别、照明、医疗设备等'},
            ],},{
                id: 6, contentTitle: '服务客户', values:[
                    {id: 1, value: '中芯国际、铅笔视界、圣戈班、科德宝、宏力、杜邦、博西、富士通、联影、广电富士、天马、敦泰、箩箕、展讯、上汽等二十几家客户'}
            ],}
        ],
    },

    {   id: 3,
        route: '',
        itemName: '潘彦君',
        contents: [{
            id: 1, contentTitle: '专业任职', values:  [
                {id: 1, value: '曾任知名企业知识产权管理人员'},
                {id: 2, value: '事务所专利代理人'},
                {id: 3, value: '事务所专利团队负责人及合伙人'}
            ],},{
            id: 2, contentTitle: '工作经历', values: [
                {id: 1, value: '逾十年专利领域从业经验'},
            ],},{
            id: 3, contentTitle: '教育经历', values:[
                {id: 1, value: '河南科技大学，自动化专业，学士'}
            ],},{
                id: 4, contentTitle: '特色专长', values: [
                    {id: 1, value: '专长于专利新申请的撰写、OA答复、复审及无效等，尤其擅长于通信、软件、电路及机电领域专利案件'},
                    {id: 2, value: '多家国内外知名企业提供知识产权法律事务服务'},
            ],},{
                id: 5, contentTitle: '服务领域', values: [
                    {id: 1, value: '通信、电路、软件、机电领域等'},
            ],},{
                id: 6, contentTitle: '服务客户', values:[
                    {id: 1, value: '沈机、好未来、明匠智能、华为、腾讯、上汽、中芯、展讯、宏力、东软载波、博西、联影、格科，复旦微、帝联等数十家客户'}
                ],}
            ],
    },

    {   id: 4,
        route: '',
        itemName: '曹守彬',
        contents: [{
            id: 1, contentTitle: '专业任职', values:  [
                {id: 1, value: '事务所专利代理人'},
                {id: 2, value: '事务所专利团队负责人及合伙人'}, 
            ],},{
                id: 2, contentTitle: '工作经历', values: [
                    {id: 1, value: '近十年专利领域从业经验'},
            ],},{
                id: 3, contentTitle: '教育经历', values:[
                    {id: 1, value: '北京交通大学，车辆工程专业，硕士'}
            ],},{
                id: 4, contentTitle: '特色专长', values: [
                    {id: 1, value: '专长于为企业提供知识产权解决方案'},
                    {id: 2, value: '专利检索、分析、FTO分析、专利挖掘及培训'},
                    {id: 3, value: '专利新申请撰写、OA答复、复审及无效等，尤其擅长于机电、控制领域专利案件'},
                    {id: 4, value: '为企业提供专利法律事务服务'}, 
            ],},{
                id: 5, contentTitle: '服务领域', values: [
                    {id: 1, value: '轨道交通、汽车、冶金、机器人、算法等'},
            ],},{
                id: 6, contentTitle: '服务客户', values:[
                    {id: 1, value: '好未来、安互保、铅笔世界、车和家、联想、中车集团、北方微电子、三一集团、天威英利、浙江三花、金蝶、广电运通、湘电、北汽、上汽、海尔、阳光电源、祥光铜业、新杰克以及快乐木业等'}
            ],},{
                id: 7, contentTitle: '学术成果', values:[
                    {id: 1, value: '文章，《知识产权咨询师做妈妈是一种什么体验》，发表于《中国知识产权》'},
                    {id: 1, value: '文章，《中国高铁“走出去”，先破知识产权“困局”》，发表于“吹IP”公众号'}
            ],}
        ],
    },

    {   id: 5,
        route: '',
        itemName: '汤成龙',
        contents: [{
            id: 1, contentTitle: '专业任职', values:  [
                {id: 1, value: '曾任知名企业知识产权管理人员'},
                {id: 2, value: '事务所专利代理人'},
                {id: 3, value: '事务所专利团队负责人及合伙人'}
            ],},{
            id: 2, contentTitle: '工作经历', values: [
                {id: 1, value: '七年多年专利领域从业经验， 累积处理700多件新申请，其中腾讯新申请200多件，答复300多件OA'},  

            ],},{
            id: 3, contentTitle: '教育经历', values:[
                {id: 1, value: '天津工业大学，光信息科学与技术，学士'}
            ],},{
                id: 4, contentTitle: '特色专长', values: [
                    {id: 1, value: '专长于专利新申请的撰写、OA答复、复审及无效等，尤其擅长于电学、通信、互联网领域等专利案件'},
                    {id: 2, value: '有丰富的重要、疑难案件处理经验，对于高质量案件有一定的体会和感悟'},
                    {id: 3, value: '曾为多家国内外知名企业提供专利法律事务服务'},
            ],},{
                id: 5, contentTitle: '服务领域', values: [
                    {id: 1, value: '电学、通信、互联网、软件、游戏、AI等领域的专利申请、审查意见答复、复审、无效及侵权分析等。'},
            ],},{
                id: 6, contentTitle: '服务客户', values:[
                    {id: 1, value: '主要包括华为、腾讯等，通过华为认证代理人，同时保持多年腾讯A级代理人'}
                ],}
            ],
    },

*/
];

